<script>
import {mapState} from 'vuex'

import { validateAndSubmit } from '../../../mixins/validateAndSubmit';
import { validationClass } from '../../../mixins/validationClass';

export default {
    data() {
        return {
            disableOnSubmit : false,
            formUrl : '',
            formData : {},
            clubAdmin : false,
        }
    },

    props: ['register', 'generalUrl', 'playerUrl'],

    mixins: [validateAndSubmit, validationClass],

    computed: {
        'actionUrl' : function() {
            if (this.formData.player != "no") {
                return this.formUrl = this.playerUrl;
            } else {
                return this.formUrl = this.generalUrl;
            }
        }
    },

    created() {
        if (this.register.length > 0) {
            this.formData = this.register;
        } else {
            this.formData = {
                player: 'no'
            };
        }
    },

    mounted() {
    },

    watch: {
    },

    methods: {
    },
}
</script>
